import Api from '@/api/index';

const Client = {
  namespaced: true,
  state: { //dado read only, e qm pode alterar esses dados são as mutations! VARIAVEIS
    oneClient: null, //para o show
    allClients: null, //para o index, e vai tomar um push(newClient ao criar)
    allClientPayments: null,
  },
  mutations: { // altera os dados do state
    getClients(state, clients) {
      state.allClients = clients.data;
    },
    getClientPayments(state, payments) {
      state.allClientPayments = payments.datas;
    },
    pushClient(state, client) {
      state.allClients.push(client);
    },
    getOneClient(state, client) {
      state.oneClient = client;
    },
    clearClient(state){
      state.oneClient = null
    },
    clearAllClients(state){
      state.allClients = null
    },
  },
  actions: { //chamar o método dentro dos componentes
    index(context, filter) {
      Api.Client.index(filter)
        .then(response => response.data)
        .then(clients => {
          context.commit('getClients', clients);
        }).catch(function (error) {
          console.log('erro no models - Client');
          console.log(error);
        });
    },
    indexPayments(context, client_id) {
      Api.Financial.clientPayments(client_id)
        .then(response => response.data)
        .then(payments => {
          context.commit('getClientPayments', payments);
        }).catch(function (error) {
          console.log('erro no models - Client');
          console.log(error);
        });
    },

    employeeClients(context, id) {
      Api.Client.employeeClients(id)
        .then(response => response.data)
        .then(clients => {
          context.commit('getClients', clients);
        }).catch(function (error) {
          console.log('erro no models - Client');
          console.log(error);
        });
    },
    setClient(context, client) {
      context.commit('getOneClient', client)
    },
    clearClient(context){
      context.commit('clearClient')
    },
    clearAllClients(context){
      context.commit('clearAllClients')
    },

  }
};

export default Client;